import React from "react";
import useApiEp from "../../hooks/useApiEp";
import { useParams } from "react-router-dom";
import MuPb from "../../widgets/MuPb";
import { Alert, Box } from "@mui/material";
import { getErrorResponse } from "../../utils/util";
import { RcsTemplatePreview } from "./RcsTemplates";

const RcsTemplateById = ({ id }) => {
  const { data, isLoading, isError, error } = useApiEp(
    `/rcs/get-template/${id}`
  );
  if (isLoading) {
    return <MuPb />;
  }
  if (isError) {
    return (
      <Box mt={3}>
        <Alert severity="error">{getErrorResponse(error)}</Alert>
      </Box>
    );
  }
  return (
    <Box>
      <RcsTemplatePreview template={data} />
    </Box>
  );
};

export default RcsTemplateById;
